import { MODES } from "../constants";
import { JSONCompletion } from "../features/completion";
/**
 * provides a JSON schema enabled autocomplete extension for codemirror and yaml
 * @group Codemirror Extensions
 */
export function yamlCompletion(opts = {}) {
    const completion = new JSONCompletion(Object.assign(Object.assign({}, opts), { mode: MODES.YAML }));
    return function jsonDoCompletion(ctx) {
        return completion.doComplete(ctx);
    };
}
